var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 314 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2916_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.934 125.558C104.435 125.531 106.936 125.476 109.438 125.311C112.378 125.118 115.265 124.513 118.206 124.238C118.618 124.21 119.635 123.963 119.993 124.238C120.515 124.651 120.268 125.833 120.103 126.411C119.113 129.546 114.99 130.619 112.214 131.252C109.767 131.829 100.559 132.847 96.8757 132.847",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.94 160.267C143.742 154.409 136.843 143.298 136.843 130.591C136.843 111.751 151.961 96.4863 170.597 96.4863C189.233 96.4863 204.351 111.751 204.351 130.591C204.351 147.148 192.669 160.955 177.194 164.063",
    stroke: "#EF6D58",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8093 142.444V145.03V151.438V185.543H136.898V132.9H89.5369",
    stroke: "#EF6D58",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.22 107.596C116.557 107.404 116.2 112.382 115.705 113.565C114.688 115.985 112.572 117.883 110.593 119.506C106.002 123.301 100.917 126.217 95.7769 129.132C92.286 131.112 87.558 133.367 85.7438 137.218C84.727 139.391 84.727 142.746 84.782 145.222V150.035C85.0843 165.794 73.4293 177.621 58.5038 179.519C43.9082 181.389 32.6109 171.377 28.8726 157.626C24.5571 141.811 30.247 126.244 42.2589 115.573C42.3964 115.463 42.5063 115.353 42.6437 115.243C55.6178 103.911 72.7973 98.548 89.7569 98.1075C107.047 97.6675 124.941 102.508 138.904 113.317C139.509 113.785 140.114 114.252 140.691 114.747",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8283 57.1547C69.4985 54.8992 68.3443 53.8542 66.7775 53.7167C65.0458 53.5792 63.9736 55.5597 64.7984 57.2922C65.403 58.5297 65.8427 59.0801 66.3653 60.3451C67.1073 62.1881 67.5195 64.1956 67.6844 66.176C67.7668 67.1935 67.7943 68.2935 68.2069 69.229C68.7291 70.384 69.9112 70.8515 71.0379 70.274C72.3299 69.6415 72.8246 68.101 72.3299 66.5885",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.532 28.3311C234.725 34.6569 236.484 40.4052 240.36 44.2832C246.764 50.664 259.491 49.289 262.322 59.5753C264.273 66.6437 256.22 70.5217 255.89 77.1776",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.121 25.9114C248.276 11.4994 260.343 0.96541 272.96 0.470342C284.944 0.0027793 293.575 8.14387 296.104 18.7879C299.567 33.2823 291.816 45.8514 284.037 57.2932C277.633 66.7546 264.109 83.1193 269.441 95.6332C271.283 99.9241 276.148 103.17 281.068 102.317C287.088 101.272 290.744 94.7532 289.205 89.8302",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.014 52.4527C138.684 48.8223 134.836 48.4098 133.819 50.8577C133.104 52.5902 133.736 54.4057 134.176 56.1111C134.644 57.8711 134.836 59.7141 135.386 61.4466C135.798 62.712 136.183 64.417 137.585 64.9395C140.031 65.8475 141.24 63.042 140.718 61.0616",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.964 52.5343C199.294 49.1789 203.087 48.4639 204.104 50.9114C204.819 52.5893 204.269 54.2943 203.774 55.9723C203.252 57.7873 202.702 59.6028 202.125 61.4178C201.713 62.6832 201.328 64.3882 199.926 64.9107C197.479 65.8187 196.27 63.0132 196.792 61.0328",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.312 25.4985C236.401 41.5882 224.939 52.4798 217.463 64.6361C198.194 95.9632 230.052 129.985 261.662 129.985C293.493 129.985 318.149 99.4561 312.707 67.9366C310.837 57.1002 306.219 47.0064 303.471 36.4175C301.162 27.4788 301.904 18.7876 305.175 11.1416",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.163 162.551C160.922 158.618 162.516 154.822 164.165 151.384C165.594 148.414 166.996 145.223 168.563 142.308C169.443 140.63 171.147 135.569 174.006 137.495C176.067 138.87 174.253 142.253 173.401 144.013C171.477 148.084 169.608 152.182 167.738 156.28C166.804 158.315 165.869 160.378 164.935 162.413C164.66 162.963 164.413 163.513 164.137 164.063",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.504 148.249C172.164 146.709 172.906 145.169 173.923 143.848C174.363 143.271 174.857 142.693 175.49 142.336C177.029 141.428 179.008 142.418 178.98 144.261C178.953 146.379 177.936 148.441 177.029 150.284C175.545 153.364 174.088 156.555 172.851 159.718C172.219 161.313 171.614 162.908 170.954 164.476C170.817 164.834 170.679 165.164 170.569 165.466",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.339 163.403C171.504 162.908 171.999 161.698 172.576 160.295C172.576 160.267 172.603 160.24 172.603 160.24C173.511 158.012 174.638 155.289 175.16 154.051C175.16 154.051 175.16 154.024 175.188 154.024C175.298 153.776 175.38 153.584 175.435 153.501C175.71 152.924 176.094 152.071 176.534 151.246C176.974 150.421 177.441 149.624 177.909 149.211C178.623 148.524 179.805 148.386 180.602 148.964C182.471 150.339 181.07 153.089 180.465 154.794C177.991 161.89 175.682 169.041 172.768 175.972C170.02 182.573 168.398 189.366 166.886 196.352C165.484 202.843 162.543 209.994 156.606 213.487C150.284 217.2 142.285 219.153 134.974 219.098C120.13 219.016 105.315 217.943 90.499 217.558C81.5931 217.338 72.0276 216.843 65.1556 210.297C58.3661 203.833 56.4695 194.317 58.3936 185.296C60.9502 173.497 64.9357 161.395 69.5809 150.284C73.0443 142.06 73.5944 136.064 77.9922 130.371C82.0602 125.118 88.6024 123.137 94.2648 120.304C101.302 116.784 108.311 112.879 114.221 107.598",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3301 66.6172C72.7973 68.3222 73.2095 70.0001 73.5947 71.6776C74.8038 77.2335 75.9035 83.5594 71.4778 88.0149C62.6821 96.8987 47.3164 95.1933 36.2667 99.8417C25.8215 104.242 17.9051 112.549 19.0596 124.842C20.8463 143.985 42.6162 145.526 51.907 131.361C61.9122 116.096 51.0547 94.8633 37.0363 87.0524C25.6565 80.699 11.3082 80.5615 0.450684 88.1524",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23 59.4108C122.906 54.6524 124.226 50.1694 124.144 46.3465C123.484 19.7228 90.3892 12.4068 74.1166 30.7243C66.4752 39.333 67.8493 49.2619 70.3784 59.1633",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.498 60.3447C142.917 69.4486 146.903 78.552 144.099 88.0133C141.625 96.3197 129.586 100.968 121.449 95.6592C111.362 89.0858 114.633 77.617 118.673 66.4231",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.661 54.048C198.991 52.2876 199.238 50.5276 199.293 48.7396C199.843 29.2946 181.729 10.6745 161.224 15.9277C143.247 20.5209 137.2 37.7933 139.179 53.6905",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.957 60.4824C195.638 64.6354 194.016 68.7333 192.944 72.9142C188.271 91.0115 200.531 104.158 210.206 117.718C211.525 119.561 212.763 121.458 213.917 123.411",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.053 162.659C159.465 161.669 159.877 160.679 160.289 159.689C161.169 157.543 162.103 155.371 163.093 153.28C164.77 149.76 166.529 146.267 168.013 142.664C168.728 140.958 170.844 136.036 167.518 135.761C165.842 135.623 164.88 137.163 164.165 138.456C163.148 140.326 162.241 142.334 161.416 144.259C160.317 146.789 158.915 149.182 157.513 151.603C155.507 155.646 153.5 159.881 153.225 164.475C152.923 169.343 153.912 174.156 153.39 179.024C152.428 187.798 147.288 195.389 150.311 205.565C153.583 216.511 168.92 219.234 178.266 219.124C183.599 219.042 188.959 218.107 193.934 216.154C207.732 210.708 218.398 198.497 223.153 184.525",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.415 66.2033C262.707 63.3979 264.384 57.8145 268.644 59.0524C271.475 59.8774 271.338 64.2779 270.513 66.3683",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.09 55.0652C231.454 55.0652 234.147 54.3497 236.484 54.9552C239.123 55.6702 239.178 57.8152 238.353 60.2631C237.501 62.7661 236.786 65.324 236.017 67.8545C235.742 68.707 235.082 70.2745 235.742 71.0995C236.181 71.6499 236.841 71.8149 237.473 71.8149",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.787 75.4727C234.697 79.8461 242.119 78.0857 247.754 74.2627",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.175 62.4632C232.938 59.7402 228.155 59.4377 225.819 62.3257",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.173 62.4632C248.936 59.7402 244.153 59.4377 241.817 62.3257",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.945 65.7919C167.958 65.8469 170.103 65.7644 170.268 61.061C170.433 55.9181 169.003 50.0047 170.872 45.1092C172.549 40.7359 177.332 37.0504 181.977 37.573",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.2 61.0327C162.193 61.0327 165.429 57.6218 165.429 53.4143C165.429 49.2068 162.193 45.7959 158.2 45.7959C154.208 45.7959 150.971 49.2068 150.971 53.4143C150.971 57.6218 154.208 61.0327 158.2 61.0327Z",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.355 61.0327C184.348 61.0327 187.584 57.6218 187.584 53.4143C187.584 49.2068 184.348 45.7959 180.355 45.7959C176.363 45.7959 173.126 49.2068 173.126 53.4143C173.126 57.6218 176.363 61.0327 180.355 61.0327Z",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.957 70.9613C163.917 75.7472 175.545 76.1047 183.516 69.1738",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.264 52.7548C168.013 52.6723 171.036 52.4248 172.933 52.4248",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3613 55.5318C75.1061 48.7934 78.0475 38.8097 74.8313 30.2285",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.972 57.2095C122.549 54.982 124.171 53.8815 125.738 53.9365C127.469 53.9915 128.349 56.0545 127.332 57.7045C126.617 58.8599 126.095 59.3824 125.463 60.5924C124.528 62.3529 123.923 64.3054 123.566 66.2583C123.374 67.2483 123.236 68.3488 122.714 69.2288C122.082 70.3288 120.845 70.6588 119.773 69.9713C118.563 69.2013 118.289 67.7983 118.701 66.2858",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.659 55.6428C116.64 48.6294 113.616 38.0405 117.491 29.2393",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8584 30.2289C78.4043 32.4291 82.0326 34.6294 86.0457 35.867C96.546 39.0849 108.365 34.7669 117.381 29.3213",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.822 46.6224H140.471C144.099 46.6224 147.068 43.6518 147.068 39.9663V33.1179C147.068 31.4676 148.387 30.1475 150.009 30.1475H177.799",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.266 46.6224H197.452C193.824 46.6224 190.855 43.6518 190.855 39.9663V33.1179C190.855 31.4676 189.536 30.1475 187.914 30.1475H160.097",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.458 53.3886C86.868 53.3886 87.2004 53.0437 87.2004 52.6186C87.2004 52.1931 86.868 51.8486 86.458 51.8486C86.0485 51.8486 85.7161 52.1931 85.7161 52.6186C85.7161 53.0437 86.0485 53.3886 86.458 53.3886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.139 53.3886C106.549 53.3886 106.881 53.0437 106.881 52.6186C106.881 52.1931 106.549 51.8486 106.139 51.8486C105.729 51.8486 105.397 52.1931 105.397 52.6186C105.397 53.0437 105.729 53.3886 106.139 53.3886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5474 77.3154C93.6322 79.1854 99.1846 79.2954 104.05 76.9854",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.075 46.7305H89.2897C92.4784 46.7305 94.9521 49.6185 94.6223 52.9465L93.3578 64.8833C93.2753 65.7633 93.9074 66.5333 94.7597 66.5333H98.8278C99.6526 66.5333 100.312 65.7908 100.23 64.9383L99.24 52.424C98.9927 49.151 101.439 46.373 104.573 46.373H114.551",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0792 66.7812C99.1574 66.7262 106.084 67.9087 107.541 72.6117C107.734 73.2721 107.266 73.9321 106.579 73.9321H86.0185C85.3315 73.9321 84.8369 73.2721 85.0567 72.6117C86.5411 67.9087 93.4401 66.6987 96.5188 66.7812",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7282 88.1254H94.8693C94.0174 88.1254 93.3574 87.4379 93.3574 86.6129V83.8074C93.3574 82.9549 94.0449 82.2949 94.8693 82.2949H97.7282C98.5801 82.2949 99.2396 82.9824 99.2396 83.8074V86.6129C99.2396 87.4654 98.5526 88.1254 97.7282 88.1254Z",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.305 175.752H255.808L220.047 112.604L184.286 175.752H227.606",
    stroke: "#EF6D58",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.627 168.518C179.146 175.779 182.746 183.012 186.925 189.915C191.075 196.736 196.051 203.145 202.372 208.013C213.642 216.732 232.829 222.04 244.181 210.626C248.798 205.978 250.008 199.267 248.524 193.023C247.424 188.32 245.39 183.782 242.861 179.684C240.415 175.696 237.336 171.983 235.824 167.473C235.357 166.097 235.247 164.447 234.368 163.237C233.488 162.027 232.224 162.632 231.399 163.567C229.255 165.987 230.519 168.903 231.014 171.653C231.564 174.706 230.437 175.751 227.359 175.751L210.179 175.806C206.028 176.026 189.948 174.899 191.515 181.472C191.68 182.215 192.587 182.49 193.219 182.517C200.751 182.765 206.936 182.517 213.752 182.82C229.255 183.535 241.762 194.619 254.653 202.017C264.604 207.711 279.31 208.701 287.858 199.212C294.62 191.703 293.933 181.527 292.778 172.286C290.662 155.453 283.488 139.831 274.966 125.419C268.589 114.638 260.508 102.619 262.817 89.6094C265.373 75.2801 275.297 62.9308 272.3 47.6661C269.524 33.3918 257.1 23.0779 242.861 23.4905C231.427 23.8205 221.559 30.8615 217.683 42.0005C213.175 54.9274 218.37 73.1072 223.125 85.0165C224.857 89.3619 226.396 94.5328 224.994 99.1808C224.005 102.399 221.558 104.984 218.755 106.634",
    stroke: "white",
    strokeWidth: 2.4132,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2916_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 314,
    height: 220,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/Hero_Illustration.58ef6d54a9e13a0662fb52de01021b98.svg";
export { ForwardRef as ReactComponent };